export const DEVURL = 'http://sdea004:8080';
export const SITURL = 'http://ssta004:8080';
export const PPURL = 'http://sppa012:8080';
export const PRODURL = 'https://mobily.com.sa'